// extracted by mini-css-extract-plugin
export default {"ring":"StatusChangeDateTemplate_ring__6DPJP","circle":"StatusChangeDateTemplate_circle__L-UvL","text":"StatusChangeDateTemplate_text__GvLkQ"};